<template>
  <footer class="site-footer">
    <div class="footer-card">
      <div class="footer-top">
        <div class="footer-branding">
          <div class="footer-brand">
            <img src="/assets/logo.png" alt="Logo Saineo" class="footer-mark" />
            <span class="footer-name">saineo</span>
          </div>
          <p class="footer-description">
            Des menus générés automatiquement, adaptés au profil médical et objectifs sportifs de chacun.
            Aucun aliment transformé, uniquement une nutrition saine et validée par la science.
          </p>
          <div class="footer-social">
            <a class="footer-social__btn" href="https://fr.linkedin.com/company/saineo" target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4.98 3.5C4.98 4.88 3.9 6 2.5 6S0 4.88 0 3.5C0 2.12 1.08 1 2.5 1s2.48 1.12 2.48 2.5zM.3 23.5h4.4V7.98H.3V23.5zM8.2 7.98h4.2v2.12h.06c.58-1.1 2-2.26 4.12-2.26 4.4 0 5.2 2.9 5.2 6.68v8.98h-4.4v-7.96c0-1.9-.04-4.34-2.64-4.34-2.64 0-3.04 2.06-3.04 4.2v8.1H8.2V7.98z"/>
              </svg>
            </a>
            <a class="footer-social__btn" href="https://www.instagram.com/@saineo.eu" target="_blank" rel="noreferrer" aria-label="Instagram">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            <a class="footer-social__btn" href="https://www.tiktok.com/@saineo.eu" target="_blank" rel="noreferrer" aria-label="TikTok">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.32 6.32 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z"/>
              </svg>
            </a>
          </div>
        </div>

        <div class="footer-columns">
          <div class="footer-col">
            <span class="footer-col__title">Pages</span>
            <router-link class="footer-link" to="/welcome">Accueil</router-link>
            <router-link class="footer-link" to="/partenaires">Professionnels</router-link>
            <router-link class="footer-link" to="/faq">FAQ</router-link>
            <router-link class="footer-link" to="/contact">Contact</router-link>
          </div>
          <div class="footer-col">
            <span class="footer-col__title">Légal</span>
            <router-link class="footer-link" to="/mentions-legales">Mentions légales</router-link>
            <router-link class="footer-link" to="/politique-cookies">Politique de cookies</router-link>
            <router-link class="footer-link" to="/politique-confidentialite">Politique de confidentialité</router-link>
            <router-link class="footer-link" to="/conditions-generales">CGU / CGV</router-link>
          </div>
        </div>
      </div>

      <div class="footer-divider" aria-hidden="true"></div>
      <div class="footer-bottom">
        © {{ new Date().getFullYear() }} Saineo. Tous droits réservés.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComp',
}
</script>

<style scoped>
  .site-footer {
    --footer-bg: #C3DBF3;
    --footer-card: #d9e8fb;
    --footer-ink: #121418;
    --footer-muted: #4a5160;
    --footer-radius: 32px;
    padding: 0 clamp(20px, 6vw, 80px) clamp(64px, 10vw, 120px);
    background: var(--footer-bg);
    font-family: "Open Runde", "Montserrat", "Segoe UI", sans-serif;
  }

  .footer-card {
    background: var(--footer-card);
    border-radius: var(--footer-radius);
    padding: clamp(28px, 4vw, 40px) clamp(28px, 5vw, 60px);
    box-shadow: 0 28px 60px rgba(20, 30, 45, 0.12);
    border: 1px solid rgba(18, 20, 24, 0.08);
    max-width: 1240px;
    margin-inline: auto;
    display: flex;
    flex-direction: column;
    gap: 28px;
    color: var(--footer-ink);
  }

  .footer-top {
    display: grid;
    grid-template-columns: minmax(240px, 1.2fr) minmax(240px, 1fr);
    gap: 32px;
    align-items: start;
  }

  .footer-brand {
    display: flex;
    align-items: center;
    gap: 12px;
    font-weight: 700;
    font-size: 1.1rem;
  }

  .footer-mark { width: 34px; height: 34px; object-fit: contain; display: block; }
  .footer-name { letter-spacing: -0.02em; }

  .footer-description {
    margin: 12px 0 0;
    color: var(--footer-muted);
    font-size: 0.98rem;
    line-height: 1.6;
    max-width: 360px;
  }

  .footer-social {
    margin-top: 16px;
    display: flex;
    gap: 12px;
  }

  .footer-social__btn {
    width: 36px;
    height: 36px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #111111;
    color: #ffffff;
    text-decoration: none;
    transition: transform 0.2s ease, opacity 0.2s ease;
  }

  .footer-social__btn:hover { transform: translateY(-2px); opacity: 0.8; }

  .footer-social__btn svg {
    width: 16px;
    height: 16px;
    fill: currentColor;
  }

  .footer-columns {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 1fr));
    gap: 24px;
    justify-items: start;
  }

  .footer-col {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .footer-col__title {
    font-weight: 700;
    font-size: 0.85rem;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: var(--footer-muted);
    margin-bottom: 4px;
  }

  .footer-link {
    color: var(--footer-ink);
    text-decoration: none;
    font-size: 0.98rem;
    opacity: 0.88;
    transition: opacity 0.2s ease;
  }

  .footer-link:hover { opacity: 1; }

  .footer-divider {
    height: 1px;
    background: rgba(30, 36, 44, 0.2);
    width: 100%;
  }

  .footer-bottom {
    font-size: 0.9rem;
    color: var(--footer-muted);
  }

  @media (max-width: 720px) {
    .footer-card { text-align: center; }
    .footer-col { align-items: center; }
    .footer-top { grid-template-columns: 1fr; }
    .footer-columns { grid-template-columns: 1fr; justify-items: center; }
    .footer-description { max-width: 100%; }
    .footer-social { justify-content: center; }
  }
</style>
